import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Report from '../components/Report'
import UpperHeader from '../components/UpperHeader'

export default function InterestSites() {
    return (
        <div>
            <UpperHeader child={false} />
            <Header />
            <Report />
            <div className="text-center p-2">
                <p className='colorblue'>
                    <h2 className='fw-bold fst-italic'>
                        Sitios de Interés
                    </h2>
                </p>
            </div>
            <img src="linea-de-color.jpg" alt='Linea Color' className='img-fluidLine reverse' style={{ marginBottom: "22px" }} />
            <div className="text-center">
                <h2 className='colorblue'>Municipio de Chihuahua</h2>
                <a target='_blank' href="https://www.municipiochihuahua.gob.mx/">https://www.municipiochihuahua.gob.mx/</a>

                <h2 className='colorblue'>Plataforma Nacional de Transparencia</h2>
                <a target='_blank' href="https://www.plataformadetransparencia.org.mx/">https://www.plataformadetransparencia.org.mx/</a>

                <h2 className='colorblue'>Auditoría Superior de la Federación</h2>
                <a target='_blank' href="https://www.asf.gob.mx/Default/Index">https://www.asf.gob.mx/Default/Index</a>

                <h2 className='colorblue'>SESEA CHIHUAHUA</h2>
                <a target='_blank' href="https://secretaria.anticorrupcion.org/">https://secretaria.anticorrupcion.org/</a>

                <h2 className='colorblue'>Auditoría Superior del Estado</h2>
                <a target='_blank' href="https://www.auditoriachihuahua.gob.mx/">https://www.auditoriachihuahua.gob.mx/</a>

                <h2 className='colorblue'>Secretaria de la Función Pública</h2>
                <a target='_blank' href="https://www.chihuahua.gob.mx/secretar%C3%ADa-de-la-funci%C3%B3n-p%C3%BAblica">https://www.chihuahua.gob.mx/secretar%C3%ADa-de-la-funci%C3%B3n-p%C3%BAblica</a>
            </div>
            <Footer showmap={false} />
        </div>
    )
}
